module.exports = __webpack_public_path__ + "img/WoSindDieZiegen.df190fc5.jpg";